import React, { Component } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import moment from "moment";

import Stars from '../../../Common/Stars';
import { constants } from '../../../../Helpers/Constants';
import { DivisionIcon, VCIcon } from '../../../Common/Buttons/TypeIcons';
import ProfileCell from '../User/ProfileCell';
import { setList } from '../../../../Actions/stakeholderActions';
import { setProfileDb } from '../../../../Actions/dataActions';
import GeneratedTypeIcons from '../../../Common/GeneratedTypeIcons';
import { UserRequested, TagDefault, UserInvited, UserRejected, UserDeactivate, UserApproved, ActivityActive, ActivityInactive, ActionUserInvite, ActionApproveUser, ActionDeactivateUser, EditDefault, EditAction, ActionRejectUser } from '../../../Common/Buttons/Icons';

//Pass a profile prop with the necessary details
class UserOverviewRow extends Component {
    constructor(props) {
        super(props);

        this.renderUserOptions = this.renderUserOptions.bind(this);
        this.deactivateUser = this.deactivateUser.bind(this);
        this.reactivateUser = this.reactivateUser.bind(this);
        this.approveUser = this.approveUser.bind(this);
        this.rejectUser = this.rejectUser.bind(this);
        this.resendInvite = this.resendInvite.bind(this);
        this.editTag = this.editTag.bind(this);
        this.deleteTag = this.deleteTag.bind(this);

        this.state = {
        };
    }

    componentDidMount() {
    }

    setRowClass(customer) {
        var className;

        if (customer.status === 'Active') {
            if ('bookings_made_last_three_months' in customer && customer.bookings_made_last_three_months.length > 0) {
                className = "row-active"
            } else if (('sh_vmh_access' in customer && customer.sh_vmh_access.length > 0 && moment(customer.sh_vmh_access[0].Created_At, "YYYY-MM-DD HH:mm:ss").startOf('day').isBefore(moment().subtract(90, 'days').startOf('day'))) && (!('bookings_made_last_three_months' in customer) || customer.bookings_made_last_three_months.length == 0)) {
                className = 'row-inactive'
            }
        } else if (customer.status === 'Inactive') {
            className = 'row-grey'
        } else if (customer.status === 'Rejected') {
            className = 'row-grey';
        } 

        if (customer.Title === null && customer.Company === null) {
            className = className + " internaltag-row"
        }

        return className;
    }

    setUserStatusIcon(customer) {
        if (customer.status === 'Active') {
            return(
                UserApproved()
            )
        } else if (customer.status === 'Inactive') {
            return(
                UserDeactivate()
            )
        } else if (customer.status === 'Rejected') {
            return(
                UserRejected()
            )
        } else if (customer.status === 'Invited') {
            return(
                UserInvited()
            )
        } else if (customer.status === 'Pending') {
            return(
                UserRequested()
            )
        } else if (customer.status === 'Internal Tag') {
            return(
                TagDefault()
            )
        }
    }

    setBookingActivityIcon(customer) {
        if (customer.status === "Active") {
            if ('bookings_made_last_three_months' in customer && customer.bookings_made_last_three_months.length > 0) {
                return(ActivityActive())
            } else if ('sh_vmh_access' in customer && customer.sh_vmh_access.length > 0 && moment(customer.sh_vmh_access[0].Created_At, "YYYY-MM-DD HH:mm:ss").startOf('day').isBefore(moment().subtract(90, 'days').startOf('day')) && (!('bookings_made_last_three_months' in customer) || customer.bookings_made_last_three_months.length == 0)) {
                return(ActivityInactive())
            } else {
                return (<img src = "images/png-icons/dash-grey.png"/>)
            }
        } else {
            return (<img src = "images/png-icons/dash-grey.png"/>)
        }
    }

    renderUserOptions(customer) {
        if (customer.status === 'Active') {
            return(
                <td className = "action-cell">
                    <a onClick={() => this.deactivateUser()}>
                        {ActionDeactivateUser()}
                    </a>
                </td>
            )
        } else if (customer.status === 'Inactive') {
            return(
                <td className = "action-cell">
                    <a onClick={() => this.reactivateUser()}>
                        {ActionApproveUser()}
                    </a>
                </td>
            )
        } else if (customer.status === 'Rejected') {
            return(
                <td className = "action-cell">
                    <a onClick={() => this.approveUser()}>
                        {ActionApproveUser()}
                    </a>
                </td>
            )
        } else if (customer.status === 'Invited') {
            return(
                <td className = "action-cell">
                    <a onClick={() => this.resendInvite()}>
                        {ActionUserInvite()}
                    </a>
                </td>
            )
        } else if (customer.status === 'Pending') {
            return(
                <td className = "action-cell">
                    <a className = "mr-8" onClick={() => this.approveUser()}>
                        {ActionApproveUser()}
                    </a>
                    <a onClick={() => this.rejectUser()}>
                        {ActionRejectUser()}
                    </a>
                </td>
            )
        } else if (customer.status === 'Internal Tag') {
            return(
                <td className = "action-cell">
                    <a className = "mr-8" onClick={() => this.editTag()}>
                        {EditAction()}
                    </a>
                    <a onClick={() => this.deleteTag()}>
                        {ActionDeactivateUser()}
                    </a>
                </td>
            )
        }
    }

    deactivateUser() {
        
        var base_url = (this.props.match.url).split('/')[1]
        this.props.history.push("/" + base_url + '/deactivateprofile/' + this.props.customer.ID);
    }

    reactivateUser() {
        if (window.confirm("Are you sure you would like to reactivate this user?")) {
            var self = this;
            axios.post('/ajax/profile/' +  this.props.customer.ID + '/activate')
            .then(function(response) {

                if (self.props.match.url.split("/")[1] === "useroverview") {
                    var data = {
                        search_term: self.props.stakeholder.previous_filters.search,
                        sort_filter: self.props.stakeholder.sort_filter,
                        sort_direction: self.props.stakeholder.sort_direction,
                        bookings_min: self.props.stakeholder.previous_filters.bookings.min,
                        bookings_max: self.props.stakeholder.previous_filters.bookings.max,
                        last_booking_min: self.props.stakeholder.previous_filters.last_booking.min,
                        last_booking_max: self.props.stakeholder.previous_filters.last_booking.max,
                        member_min: self.props.stakeholder.previous_filters.member.min,
                        member_max: self.props.stakeholder.previous_filters.member.max
                    }
    
    
                    var filters = self.props.stakeholder.previous_filters;
                    var categories = Object.keys(filters);
                    for (var i = 0; i < categories.length; i++) {
                        data[categories[i]] = "";
                        if (categories[i] !== "bookings" || categories[i] !== "last_booking" || categories[i] !== "member") {
                            var items = Object.keys(filters[categories[i]]);
                            for (var k = 0; k < items.length; k++) {
                                if (filters[categories[i]][items[k]] === true) {
                                    if (data[categories[i]] === "") {
                                        data[categories[i]] = items[k]
                                    } else {
                                        data[categories[i]] = data[categories[i]] + "#" + items[k]
                                    }
                                }
                            }
                        }
                    }
    
                    axios({
                        method: 'post',
                        url: '/ajax/user_list/update',
                        data: data
                    })
                    .then(function(response2) {
                        self.props.dispatch(setProfileDb(response2.data.data.data, self.props.data.profile_db));
                        self.props.dispatch(setList("SET_USER_LIST", response2.data.data.data))
                    })
                    .catch(function(error) {
                        if(error.response?.status == 401){
                            showStatusMsg(error.response?.data.error);
                        } else if(error.response?.status == 422) {
                            var error_message = "";
        
                            $.each(error.response?.data.errors, function (index, element) {
                                error_message += element + '<br />';
                            });
        
                            showStatusMsg(error_message);
                        } else {
                            showStatusMsg("Requested information not found");
                        }
                    })
                } else {
                    axios({
                        method: 'post',
                        url: '/ajax/user_list/update'
                    })
                    .then(function(response2) {
                        self.props.dispatch(setProfileDb(response2.data.customers, self.props.data.profile_db));
                        self.props.dispatch(setList("SET_USER_LIST", response2.data.customers))
                    })
                    .catch(function(error) {
                        if(error.response?.status == 401){
                            showStatusMsg(error.response?.data.error);
                        } else if(error.response?.status == 422) {
                            var error_message = "";
        
                            $.each(error.response?.data.errors, function (index, element) {
                                error_message += element + '<br />';
                            });
        
                            showStatusMsg(error_message);
                        } else {
                            showStatusMsg("Requested information not found");
                        }
                    })
                }
                showStatusMsg(response?.data.message, 'success');
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        } 
    }

    approveUser() {
        var self = this;
        axios.post('/ajax/profile/' +  this.props.customer.ID + '/approve')
        .then((response) => {
            var data = {
                search_term: self.props.stakeholder.previous_filters.search,
                sort_filter: self.props.stakeholder.sort_filter,
                sort_direction: self.props.stakeholder.sort_direction,
                bookings_min: self.props.stakeholder.previous_filters.bookings.min,
                bookings_max: self.props.stakeholder.previous_filters.bookings.max,
                last_booking_min: self.props.stakeholder.previous_filters.last_booking.min,
                last_booking_max: self.props.stakeholder.previous_filters.last_booking.max,
                member_min: self.props.stakeholder.previous_filters.member.min,
                member_max: self.props.stakeholder.previous_filters.member.max
            }


            var filters = self.props.stakeholder.previous_filters;
            var categories = Object.keys(filters);
            for (var i = 0; i < categories.length; i++) {
                data[categories[i]] = "";
                if (categories[i] !== "bookings" || categories[i] !== "last_booking" || categories[i] !== "member") {
                    var items = Object.keys(filters[categories[i]]);
                    for (var k = 0; k < items.length; k++) {
                        if (filters[categories[i]][items[k]] === true) {
                            if (data[categories[i]] === "") {
                                data[categories[i]] = items[k]
                            } else {
                                data[categories[i]] = data[categories[i]] + "#" + items[k]
                            }
                        }
                    }
                }
            }

            axios({
                method: 'post',
                url: '/ajax/user_list/update',
                data: data
            })
            .then(function(response) {
                self.props.dispatch(setProfileDb(response?.data.customers, self.props.data.profile_db));
                self.props.dispatch(setList("SET_USER_LIST", response?.data.customers))
    
                self.setState({
                    loading_customers: false,
                    customers_data: response?.data
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
            showStatusMsg(response?.data.message, 'success');
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    rejectUser() {
        
        var base_url = (this.props.match.url).split('/')[1]
        this.props.history.push("/" + base_url + '/rejectuser/' +  this.props.customer.ID);
    }

    resendInvite() {
        
        axios.post('/ajax/invitation/' + this.props.customer.ID + '/email', {
            invite_id: this.props.customer.ID,
            sh_id:  this.props.customer.stakeholder.SH_ID
        })
        .then(function(response) {
            showStatusMsg(response?.data.message, 'success')
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    editTag() {
        var base_url = (this.props.match.url).split('/')[1]
        this.props.history.push("/" + base_url + '/internaltag/' + this.props.customer.ID + '/edit');
    }

    deleteTag() {
        var base_url = (this.props.match.url).split('/')[1]
        this.props.history.push("/" + base_url + '/deactivateprofile/' + this.props.customer.ID);
    }
    
    render() {
        return (
            <tr className={this.setRowClass(this.props.customer)} key={"user_" + this.props.customer.sh_vmh_access.length + "" + this.props.customer.ID + "" + this.props.customer.sh_requests.length} data-key={"user_" + this.props.customer.sh_vmh_access.length + "" + this.props.customer.ID + "" + this.props.customer.sh_requests.length}>
                <td>
                    <ProfileCell history={this.props.history} match={this.props.match} location={this.props.location} profile={this.props.customer} showImage noTooltip/>
                    {/* 
                    <div className = "user-prof-img float-left">
                        <img src = "images/userrole/press.png" className = "userrole-img"/>
                    </div>
                    <div className = "user-prof-name float-left">
                        Joel Fuller
                        <div className = "caption">Journalist at autoTRADER</div>
                    </div>
                    */}
                </td>
                <td className = "single-img-cell align-center">
                    {this.setUserStatusIcon(this.props.customer)}
                </td>
                <td className = "single-img-cell align-center">
                    {this.setBookingActivityIcon(this.props.customer)}
                </td>
                <td className = "multi-img-cell px-26 align-center">
                    <GeneratedTypeIcons customer={this.props.customer} type={'Department'} />
                </td>
                <td className = "multi-img-cell px-26 align-center">
                    <GeneratedTypeIcons customer={this.props.customer} type={'Centre'} />
                </td>
                {
                    this.props.customer.tier || (this.props.customer.sh_vmh_access.length > 0 && this.props.customer.sh_vmh_access[0].tier) || (this.props.customer.sh_requests.length > 0 && this.props.customer.sh_requests[0].tier) ?
                        <td>
                            <Stars type={"Profile"} ID={this.props.customer.ID} key={this.props.customer.ID}  star={(
                                this.props.customer.status === "Invited" ? 
                                    this.props.customer.tier.Rank 
                                : 
                                    'sh_vmh_access' in this.props.data.profile_db[this.props.customer.ID] && this.props.data.profile_db[this.props.customer.ID].sh_vmh_access.length > 0 && "tier" in this.props.data.profile_db[this.props.customer.ID].sh_vmh_access[0]?
                                        this.props.data.profile_db[this.props.customer.ID].sh_vmh_access[0].tier.Rank
                                    :
                                        'sh_requests' in this.props.data.profile_db[this.props.customer.ID] && this.props.data.profile_db[this.props.customer.ID].sh_requests.length > 0 && "tier" in this.props.data.profile_db[this.props.customer.ID].sh_requests[0]?
                                            this.props.data.profile_db[this.props.customer.ID].sh_requests[0].tier.Rank
                                        :
                                            <td className="single-img-cell">
                                                <img src = "images/png-icons/dash-grey.png"/> 
                                            </td>
                            )} mutable={this.props.customer.has_authorizing ? "mutable" : ""} confirmable/>
                        </td>
                    :
                        <td className="single-img-cell">
                            <img src = "images/png-icons/dash-grey.png"/> 
                        </td>
                }
                <td className = "single-img-cell">
                    {this.props.customer.bookings.length}
                </td>
                <td className = "single-img-cell">
                    {
                        'last_booking' in this.props.customer && this.props.customer.last_booking !== null ?
                            moment(this.props.customer.last_booking.End_Date, "YYYY-MM-DD").format("MMM DD, YYYY")
                        :
                            <img src = "images/png-icons/dash-grey.png"/> 
                    }
                </td>
                <td className = "single-img-cell">
                    {
                        'sh_vmh_access' in this.props.customer && this.props.customer.sh_vmh_access.length > 0 ?
                            moment(this.props.customer.sh_vmh_access[0].Created_At, "YYYY-MM-DD HH:mm:ss").format("MMM DD, YYYY")
                        :
                            <img src = "images/png-icons/dash-grey.png"/> 
                    }
                </td>
                {this.renderUserOptions(this.props.customer)}
            </tr>
        );
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    stakeholder: store.stakeholder
})

export default connect(mapStateToProps)(UserOverviewRow)